module.exports = __webpack_public_path__ + "img/maserati.b18cf73e.jpg";